type IconRendererProps = {
  icon: string | React.ReactNode;
  size?: number | string;
  color?: string;
};

export const IconRenderer: React.FC<IconRendererProps> = ({ icon, size = 20, color = '#667085' }) => {
  if (typeof icon === 'string') {
    return <i className={icon} style={{ fontSize: size, color }} />;
  }
  return <>{icon}</>;
};
